<template>
  <div class="bindCard" v-if="show">
    <div class="backdrop" @click.self="dismiss"></div>
    <div class="dialogContent" ref="dialogContent">
      <span class="close" @click="dismiss"><img src="/static/img/order-close.png" alt=""></span>
      <table>
        <thead>
          <tr>
            <th>期数</th>
            <th>应还本金</th>
            <th>应还利息</th>
            <th>剩余本金</th>
            <th>状态</th>
            <th>到期日期</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{item.phaseNum}}</td>
            <td>{{item.principal}}</td>
            <td>{{item.normalInterest}}</td>
            <td>{{item.remainPrincipal}}</td>
            <td>{{item.status}}</td>
            <td>{{item.endDate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      list: []
    }
  },
  methods: {
    dismiss () {
      this.show = false
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../stylus/mixin'
@import '../../stylus/base'
@import '../../stylus/form'
.bindCard
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 1000
  .backdrop
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    background-color rgba(0, 0, 0, 0.5)
  .dialogContent
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    -ms-transform translate(-50%, -50%)
    width 920px
    max-height 80%
    overflow auto
    background-color #fff
    padding 30px 0 0
    border-radius 2px
    .close
      opacity 0.5
      position absolute
      right 15px
      top 15px
      z-index 10
      &:hover
        opacity 1
      img
        display block
table
  margin 0
  width 100%
  border-collapse collapse
  thead
    th
      line-height 50px
      text-align center
      font-weight bold
  tbody
    tr
      height 50px
      border-top 1px solid #e0e0e0
    td
      line-height 24px
      padding 13px 10px
      text-align center

</style>



// WEBPACK FOOTER //
// repaymentPlan.vue?8b7ee02a